import React, { useEffect, useState } from "react";
import axios from "axios";

export default function CommentsPage() {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchComments() {
            try {
                const res = await axios.get("api/manage/comments");
                setComments(res.data);
            } catch (err) {
                console.error("댓글 목록을 불러오지 못했습니다.", err);
            } finally {
                setLoading(false);
            }
        }
        fetchComments();
    }, []);

    const handleDelete = async (commentId) => {
        if (!window.confirm("정말로 삭제하시겠습니까?")) return;
        try {
            await axios.delete(`api/manage/comments/${commentId}`);
            setComments(comments.filter(c => c.id !== commentId));
            alert("삭제 성공");
        } catch (err) {
            alert("삭제 실패: " + err.message);
        }
    };

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }

    return (
        <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>댓글 리스트</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <th style={thStyle}>사무소(ID)</th>
                        <th style={thStyle}>작성 유저(ID)</th>
                        <th style={thStyle}>평점</th>
                        <th style={thStyle}>내용</th>
                        <th style={thStyle}>작성일</th>
                        <th style={thStyle}>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {comments.length > 0 ? comments.map((item, idx) => (
                        <tr key={item.id || idx}>
                            <td style={tdStyle}>{item.memberId}</td>
                            <td style={tdStyle}><a href={`/users/${item.userId}`}>{item.userId}</a></td>
                            <td style={tdStyle}>{item.rating}</td>
                            <td style={tdStyle}>{item.detail}</td>
                            <td style={tdStyle}>{new Date(item.createdAt).toLocaleDateString()}</td>
                            <td style={tdStyle}>
                                <button
                                    style={{
                                        background: "#ff4d4f",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "6px 16px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleDelete(item.id)}
                                >
                                    삭제
                                </button>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={6} style={{ textAlign: "center", color: "#888", padding: 24 }}>
                                댓글이 없습니다.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

const thStyle = {
    padding: "10px 8px",
    borderBottom: "2px solid #e1e1e1",
    fontWeight: 600,
    background: "#f5f6fa"
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #f0f0f0",
    textAlign: "center"
};